
import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {ReplacementDetailsModel} from "@/api-client";

@Component
export default class ReplacementDetails extends Vue {
    @Prop({required: true})
    details!: ReplacementDetailsModel;
}
